import { ChangeDetectionStrategy, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';

import { TranslateModule } from '@ngx-translate/core';
import { ClipboardService } from 'ngx-clipboard';

import { ButtonComponent } from '../button/button.component';

interface ErrorData {
  token: string;
}

@Component({
  templateUrl: './error-popup.component.html',
  styleUrls: ['./error-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatTooltip, TranslateModule, ButtonComponent],
})
export class ErrorPopupComponent {
  @ViewChild('container') container: ElementRef<HTMLElement>;

  public hasToken: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly _data: ErrorData,
    private readonly _dialog: MatDialogRef<ErrorPopupComponent>,
    private readonly _clipboardService: ClipboardService,
  ) {
    this.hasToken = !!(this._data && this._data.token);
  }

  public copy(): void {
    this._clipboardService.copyFromContent(
      this._data.token,
      this.container.nativeElement,
    );
  }

  public close(): void {
    this._dialog.close();
  }
}
